import type {
  PlanApi,
} from "@/types/plan";
import { commercialFeatureModality, type CommercialModality } from "@/lib/commercial-plan-presentation";

export type MarketingPlan = {
  slug: string;
  buttonLabel: string;
  highlighted?: boolean;
  badge?: string;
  inheritedFeature?: string;
  baseFeatures: string[];
};

export const marketingPlans: Record<
  string,
  MarketingPlan
> = {
  profissional: {
    slug: "profissional",
    buttonLabel: "Começar agora",
    highlighted: false,
    badge: undefined,
    baseFeatures: [
      "Suporte por WhatsApp",
      "Selo Empresa Verificada",
    ],
  },

  elite: {
    slug: "elite",
    buttonLabel: "Assinar Premium",
    highlighted: true,
    badge: "Mais escolhido",
    inheritedFeature: "Tudo do plano Profissional",
    baseFeatures: [
      "Prioridade nos resultados de busca",
      "URL exclusiva da loja (empresa.fornecedor.net)",
    ],
  },

  enterprise: {
    slug: "enterprise",
    buttonLabel: "Assinar Enterprise",
    inheritedFeature: "Tudo do plano Premium",
    baseFeatures: [
      "Máxima capacidade para sua operação",
      "Até 10 usuários administradores",
    ],
  },
};

export function getMarketingPlan(
  slug: string,
): MarketingPlan | undefined {
  return marketingPlans[slug];
}

export function buildPlanFeatures(
  plan: PlanApi,
  audience?: CommercialModality,
): string[] {
  return plan.commercial_features
    .filter(feature => !audience || commercialFeatureModality(feature) === audience)
    .slice()
    .sort(
      (first, second) =>
        first.position - second.position,
    )
    .map((feature) => feature.name);
}
